import * as React from "react";
import { Intent } from "@focus/focusUI";
import { getUiProperties, setNumberToLength } from "../utils/utils";
import { getNumericValueFromString, isValidNumber, getValueOrDefault, isNotADisplacementKey, isGreateMaxLength, truncateReal, isNotNaN, } from "./utils";
import { changeFromSchemaAndValue } from "../entities/formData";
export class NumericReal extends React.Component {
    constructor(props) {
        super(props);
        this.inputRef = React.createRef();
        this.onKeyUp = (event) => {
            const key = event.key;
            if (key.includes("Arrow")) {
                this.setState({
                    cursorPointer: this.inputRef.current.selectionStart,
                });
            }
            else if (key !== "Enter" && key !== "Backspace" && key !== "Tab") {
                this.inputRef.current.selectionStart = this.state.cursorPointer;
                this.inputRef.current.selectionEnd = this.state.cursorPointer;
            }
        };
        this.onChange = (event) => {
            this.handleValueChange(event.target.value, event.target.selectionStart);
        };
        this.checkRealInput = (value) => (e) => {
            if (!e.ctrlKey &&
                !e.metaKey &&
                isNotADisplacementKey(e.key) &&
                !isValidNumber(value)) {
                e.preventDefault();
            }
        };
        this.handleValueChange = (_valueAsString, cursorPointer) => {
            if (isValidNumber(_valueAsString)) {
                let parsedValue = _valueAsString;
                if (isGreateMaxLength(this.props.schema, _valueAsString)) {
                    try {
                        parsedValue = truncateReal(_valueAsString, this.props.schema.maxLength);
                        this.props.notify({
                            message: `${_valueAsString} has been truncated to ${parsedValue}`,
                            intent: Intent.WARNING,
                        });
                    }
                    catch (error) {
                        this.props.notify({
                            message: `${error.message}`,
                            intent: Intent.DANGER,
                        });
                        return;
                    }
                }
                this.setState({ stringValue: parsedValue, cursorPointer: cursorPointer });
                const value = getNumericValueFromString(parsedValue);
                this.props.onChange(value, changeFromSchemaAndValue(this.props.schema, value));
            }
        };
        this.getLongestValueSize = (schema) => {
            let size = 15;
            if (schema.type === "array") {
                if (schema.items.maxLength !== undefined)
                    size = schema.items.maxLength;
            }
            if (schema.type === "number") {
                if (schema.maxLength !== undefined)
                    size = schema.maxLength;
            }
            return size;
        };
        this.state = {
            stringValue: getValueOrDefault(props),
            cursorPointer: 0,
        };
    }
    componentDidUpdate(prevProps) {
        if (isNotNaN(this.props.formData) &&
            prevProps.formData !== this.props.formData &&
            this.props.formData != getNumericValueFromString(this.state.stringValue)) {
            this.setState({
                stringValue: getValueOrDefault(this.props),
            });
        }
    }
    componentDidMount() {
        let value = isNotNaN(this.props.formData)
            ? this.props.formData.toString()
            : "";
        if (value === "" ||
            !isValidNumber(value) ||
            typeof this.props.formData === "object") {
            const value = getNumericValueFromString(this.state.stringValue);
            this.props.onChange(value, changeFromSchemaAndValue(this.props.schema, value));
        }
    }
    render() {
        const { uiSchema } = this.props;
        const { isDisabled, isReadOnly } = getUiProperties(uiSchema);
        const { className } = this.props;
        let value;
        if (this.state.stringValue.length > this.props.schema.maxLength &&
            isNotNaN(Number(this.state.stringValue)) &&
            Number(this.state.stringValue) !== null) {
            value = setNumberToLength(Number(this.state.stringValue), this.props.schema.maxLength);
        }
        else {
            value = this.state.stringValue;
        }
        return (React.createElement("input", { style: {
                width: this.getLongestValueSize(this.props.schema) + 5 + "ch",
            }, type: "text", ref: this.inputRef, disabled: isDisabled, readOnly: isReadOnly, className: className, value: value, onKeyDown: this.checkRealInput(value), onChange: (event) => this.onChange(event), onKeyUp: this.onKeyUp }));
    }
}
//# sourceMappingURL=NumericReal.js.map